import React from "react";
import { Modal, ActionButton, Text } from "components/commons";
import lang from "translations";

const SiigoInfoModel = ({ active, close }) => {
  return (
    <Modal
      active={active}
      noCloseButton
      close={close}
      title={lang.connectToSiigo}
      actionContent={
        <ActionButton
          className="px-md py-md"
          secondary={null}
          primary={{
            text: lang.ok,
            onClick: () => {
              close();
            },
          }}
        />
      }
    >
      <Text>{lang.connectToSiigoDesc}</Text>
    </Modal>
  );
};

export default SiigoInfoModel;
